import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c84bdf6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rss_activity" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = {
  key: 0,
  class: "news"
}
const _hoisted_4 = { class: "news-line-lt" }
const _hoisted_5 = {
  key: 0,
  class: "news-line-status color1"
}
const _hoisted_6 = {
  key: 1,
  class: "news-line-status color2"
}
const _hoisted_7 = {
  key: 2,
  class: "news-line-status color3"
}
const _hoisted_8 = {
  key: 3,
  class: "news-line-status color4"
}
const _hoisted_9 = {
  key: 4,
  class: "news-line-status color5"
}
const _hoisted_10 = {
  key: 5,
  class: "news-line-status color6"
}
const _hoisted_11 = { style: {"font-size":"14px","font-weight":"bold","color":"#3399ff"} }
const _hoisted_12 = { class: "news-line-rt" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';

interface RssActivityReadVo {
  id: string;
  rssCompanyId: string;
  rssCompanyCode: string;
  rssCompanyName: string;
  rssCompanyLogo: string;
  rssCompanyShortName: string;
  rssActivityId: string;
  isRead: string;
  activityName: string;
  activityStatus: string;
  activityThumbnailUrl: string;
  activityImgUrl: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);

const bindData = reactive({
  activityStatusOptions: [
    {
      value: '',
      label: '活动状态',
    },
    {
      value: '3',
      label: '报名中',
    },
    {
      value: '4',
      label: '已开始',
    },
    {
      value: '5',
      label: '已结束',
    },
    {
      value: '6',
      label: '已取消',
    },
  ],
  readStatusOptions: [
    {
      value: '',
      label: '阅读状态',
    },
    {
      value: 'Y',
      label: '已读',
    },
    {
      value: 'N',
      label: '未读',
    },
  ],
  searchTimeOptions: [
    {
      value: '',
      label: '不限时间',
    },
    {
      value: '1',
      label: '近7天',
    },
    {
      value: '2',
      label: '近30天',
    },
    {
      value: '3',
      label: '近半年',
    },
  ],
  rssActivityPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      isRead: '',
      activityStatus: '',
      searchTime: '',
      keyword: '',
    },
  },
  rssActivityPageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
});

const handleSizeChangeEvent = (value: any) => {
  bindData.rssActivityPageParams.pageSize = value;
  bindData.rssActivityPageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.rssActivityPageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  store
    .dispatch(
      'newsModule/pageRssActivityReadList',
      bindData.rssActivityPageParams
    )
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          if (!obj.rssCompanyLogo || obj.rssCompanyLogo.length <= 0) {
            obj.rssCompanyLogo = require('@/assets/no_pict.png');
          }
          if (
            !obj.activityThumbnailUrl ||
            obj.activityThumbnailUrl.length <= 0
          ) {
            obj.activityThumbnailUrl = require('@/assets/no_pict.png');
          }
          if (!obj.activityImgUrl || obj.activityImgUrl.length <= 0) {
            obj.activityImgUrl = require('@/assets/no_pict.png');
          }
        }
        bindData.rssActivityPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();

const goActivityDetailPage = (type: number, activityId: string) => {
  switch (type) {
    case 1:
      //楼盘招商
      router.push('/frontDesk/fdInvestList/fdInvestDetail/' + activityId);
      break;
    case 2:
      //社区营销
      router.push('/frontDesk/bbsList/bbsDetail/' + activityId);
      break;
    case 3:
      //经销商招募
      break;
    case 4:
      //培训
      break;
    case 5:
      //行业会议
      break;
    case 6:
      //私享会
      break;
    case 7:
      //拎包商加盟
      break;
    default:
      break;
  }
};

const getActivityTypeInfo = (type: number) => {
  switch (type) {
    case 1:
      return '楼盘招商';
    case 2:
      return '社区营销';
    case 3:
      return '经销商招募';
    case 4:
      return '拎包培训';
    case 5:
      return '行业会议';
    case 6:
      return '私享会';
    case 7:
      return '拎包商加盟';
    default:
      return '';
  }
};

const updateIsReadEvent = (row: RssActivityReadVo) => {
  ElMessageBox.confirm(`您确定要对当前消息标记为已读吗?`)
    .then(() => {
      const params = {
        id: row.id,
        isRead: 'Y',
      };
      store.dispatch('newsModule/updateRssActivityReadStatus', params).then(
        (data) => {
          //成功
          ElMessage.success('操作成功.');
          searchEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, '系统消息', {
            confirmButtonText: '关闭',
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "rss_activity-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "rss_activity-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { style: {"margin-right":"18px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).rssActivityPageParams.filtrate.isRead,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).rssActivityPageParams.filtrate.isRead) = $event)),
                  placeholder: "阅读状态",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).readStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"margin-right":"18px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).rssActivityPageParams.filtrate.activityStatus,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).rssActivityPageParams.filtrate.activityStatus) = $event)),
                  placeholder: "活动状态",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).rssActivityPageParams.filtrate.searchTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).rssActivityPageParams.filtrate.searchTime) = $event)),
                  placeholder: "不限时间",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).searchTimeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "rss_activity-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "",
                  size: "large",
                  modelValue: _unref(bindData).rssActivityPageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).rssActivityPageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "rss_activity-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(bindData).rssActivityPageResult.totalCount > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).rssActivityPageResult.result, (item) => {
                return (_openBlock(), _createBlock(_component_el_col, { key: item }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { class: "news-line" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            (item.isRead == 'Y')
                              ? (_openBlock(), _createBlock(_component_Message, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_Message, {
                                  key: 1,
                                  style: {"color":"blue"},
                                  onClick: ($event: any) => (updateIsReadEvent(item))
                                }, null, 8, ["onClick"]))
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_4, [
                          (item.activityStatus == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 草稿 "))
                            : _createCommentVNode("", true),
                          (item.activityStatus == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 待审核 "))
                            : _createCommentVNode("", true),
                          (item.activityStatus == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 报名中 "))
                            : _createCommentVNode("", true),
                          (item.activityStatus == 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 已开始 "))
                            : _createCommentVNode("", true),
                          (item.activityStatus == 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 已结束 "))
                            : _createCommentVNode("", true),
                          (item.activityStatus == 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 已取消 "))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(getActivityTypeInfo(item.activityType)), 1),
                            _createTextVNode("   " + _toDisplayString(item.updateTime), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (
                  goActivityDetailPage(item.activityType, item.rssActivityId)
                ),
                            class: "news-line-title"
                          }, _toDisplayString(item.activityName), 9, _hoisted_13),
                          _createElementVNode("div", null, _toDisplayString(item.rssCompanyName), 1)
                        ]),
                        _createVNode(_component_el_image, {
                          class: "news-img",
                          src: item.activityThumbnailUrl,
                          fit: "fill",
                          lazy: true
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无数据")),
    _createVNode(_component_el_container, { class: "rss_activity-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).rssActivityPageParams.curPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).rssActivityPageParams.curPage) = $event)),
          "page-size": _unref(bindData).rssActivityPageParams.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).rssActivityPageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).rssActivityPageResult.totalCount,
          "onUpdate:total": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).rssActivityPageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})